<template>
  <div class="container">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('student.back') }}</span>
    </div>
    <div class="header">
      <div class="title">{{ $t('student.title') }}</div>
      <div>
        <a-button type="primary" @click="create">{{ $t('student.create') }}</a-button>
        <a-button type="primary" @click="uploadModal">{{ $t('student.batchImport') }}</a-button>
        <a-button type="primary" @click="exportFile">{{ $t('student.batchExport') }}</a-button>
      </div>
    </div>
    <div class="content">
      <!-- <div v-if="list.length === 0" class="nodata">
        <img src="@/assets/img/bj_zanwushujv.png" alt="">
        <div>
          <div class="text">暂无学生</div>
        </div>
      </div> -->
      <div class="list">
        <a-table row-key="id" :locale="locale" :columns="columns" :data-source="list">
          <template slot="operate" slot-scope="text, record">
            <div class="operate">
              <span @click="editModal(record)">{{ $t('student.operations.edit') }}</span>
              <span @click="reviewModal(record)">{{ $t('student.operations.view') }}</span>
              <span @click="moveModal(record)">{{ $t('student.classStudent.move') }}</span>
              <span @click="delModal(record.id)">{{ $t('student.operations.delete') }}</span>
            </div>
          </template>
        </a-table>
      </div>
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handleTableChange" />
    </div>
    <a-modal :title="editId ? $t('student.edit') : $t('student.create')" :visible="visible" @ok="ok" @cancel="visible = false">
      <a-form :form="form">
        <a-form-item :label="$t('student.form.name.label')" :colon="false">
          <a-input
            maxLength="20"
            v-decorator="['name', { rules: [{ required: true, message: $t('student.form.name.required') }] }]"
            :placeholder="$t('student.form.name.placeholder')"
          />
        </a-form-item>
        <a-form-item :label="$t('student.form.username.label')" :colon="false">
          <a-input
            maxLength="13"
            :addon-after="shortName"
            v-decorator="['username', { rules: [{ required: true, message: $t('student.form.username.required') }] }]"
            :placeholder="$t('student.form.username.placeholder')"
          />
        </a-form-item>
        <a-form-item :label="$t('student.form.password.label')" :colon="false">
          <a-input
            :type="!passwordFlag ? 'password' : 'text'"
            autocomplete="autocomplete"
            v-decorator="['password', { rules: [{ required: !editId, message: $t('student.form.password.required') }] }]"
            :placeholder="$t('student.form.password.placeholder')"
          >
            <img
              @click="passwordFlag = true"
              v-if="!passwordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('student.form.confirmPassword.label')" :colon="false">
          <a-input
            :type="!repasswordFlag ? 'password' : 'text'"
            autocomplete="autocomplete"
            v-decorator="[
              'repassword',
              { rules: [{ required: !editId, message: $t('student.form.confirmPassword.required') }, { validator: compareToFirstPassword }] }
            ]"
            :placeholder="$t('student.form.confirmPassword.placeholder')"
          >
            <img
              @click="repasswordFlag = true"
              v-if="!repasswordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="repasswordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('student.form.gender.label')" :colon="false">
          <a-select
            v-decorator="['gender', { rules: [{ required: true, message: $t('student.form.gender.required') }] }]"
            :placeholder="$t('student.form.gender.placeholder')"
          >
            <a-select-option value="1">{{ $t('student.form.gender.male') }}</a-select-option>
            <a-select-option value="2">{{ $t('student.form.gender.female') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('personal.form.email')" :colon="false">
          <a-input
            maxLength="50"
            v-decorator="[
              'email',
              {
                rules: [{ validator: validateEmail }]
              }
            ]"
            :placeholder="$t('personal.form.modal.placeholder.email')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.phone')" :colon="false">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{ validator: validatePhone }]
              }
            ]"
            :placeholder="$t('personal.form.modal.placeholder.phone')"
            @input="handlePhoneInput"
          />
        </a-form-item>

        <a-form-item :label="$t('personal.form.department')" :colon="false">
          <a-input
            maxLength="20"
            v-decorator="['department']"
            :placeholder="$t('personal.form.modal.placeholder.department')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.enrollmentYear')" :colon="false">
          <a-select
            allowClear
            v-decorator="['enrollmentYear', { rules: [{ required: true, message: $t('personal.form.modal.placeholder.enrollmentYear') }] }]"
            :placeholder="$t('personal.form.modal.placeholder.enrollmentYear')"
          >
            <a-select-option v-for="year in yearList" :key="year" :value="year">
              {{ year }}{{ $t('student.yearSuffix') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('personal.form.studentNumber')" :colon="false">
          <a-input
            maxLength="30"
            v-decorator="['studentNumber']"
            :placeholder="$t('personal.form.modal.placeholder.studentNumber')"
          />
        </a-form-item>
        <a-form-item :label="$t('student.form.remark.label')" :colon="false">
          <a-textarea
            :rows="4"
            maxLength="500"
            v-decorator="['remark']"
            :placeholder="$t('student.form.remark.placeholder')"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :width="800" :title="$t('student.view')" :footer="null" :visible="reviewVisible" @cancel="reviewVisible = false">
      <a-form :form="reviewForm">
        <a-form-item :label="$t('student.form.name.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['name', { rules: [{ required: true, message: $t('student.form.name.required') }] }]"
            :placeholder="$t('student.form.name.placeholder')"
          />
        </a-form-item>
        <a-form-item :label="$t('student.form.gender.label')" :colon="false">
          <a-select
            disabled
            v-decorator="['gender']"
            :placeholder="$t('student.form.gender.placeholder')"
          >
            <a-select-option value="1">{{ $t('student.form.gender.male') }}</a-select-option>
            <a-select-option value="2">{{ $t('student.form.gender.female') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('student.form.username.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['username', { rules: [{ required: true, message: $t('student.form.username.required') }] }]"
            :placeholder="$t('student.form.username.placeholder')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.phone')" :colon="false">
          <a-input
            disabled
            v-decorator="['phone']"
            :placeholder="$t('personal.form.modal.placeholder.phone')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.email')" :colon="false">
          <a-input
            disabled
            v-decorator="['email']"
            :placeholder="$t('personal.form.modal.placeholder.email')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.department')" :colon="false">
          <a-input
            disabled
            v-decorator="['department']"
            :placeholder="$t('personal.form.modal.placeholder.department')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.studentNumber')" :colon="false">
          <a-input
            disabled
            v-decorator="['studentNumber']"
            :placeholder="$t('personal.form.modal.placeholder.studentNumber')"
          />
        </a-form-item>
        <a-form-item :label="$t('personal.form.enrollmentYear')" :colon="false">
          <a-select
            disabled
            v-decorator="['enrollmentYear']"
            :placeholder="$t('personal.form.modal.placeholder.enrollmentYear')"
          >
            <a-select-option v-for="year in yearList" :key="year" :value="year">
              {{ year }}{{ $t('student.yearSuffix') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('student.form.remark.label')" :colon="false">
          <a-textarea
            disabled
            :rows="4"
            v-decorator="['remark']"
            :placeholder="$t('student.form.remark.placeholder')"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <upload-modal
      :visible="uploadVisible"
     :title="$t('student.upload.title')"
      @upload="uploadStudentFile"
      @cancel="uploadVisible = false"
      @fileChange="handleChange"
      @downloadTemplate="uploadTemplate"
    />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`<p>${$t('student.deleteConfirm.title')}</p>`"
    />
    <!-- 添加移动学生模态框 -->
    <a-modal :title="$t('student.classStudent.moveStudent')" :visible="moveVisible" @ok="handleMove" @cancel="moveVisible = false">
      <a-form-model ref="moveForm" :model="moveForm" :rules="moveRules">
        <a-form-model-item :label="$t('student.classStudent.moveTo')" prop="majorId" v-if="moveForm.type === '1'">
          <a-cascader
            v-model="moveForm.majorId"
            class="search-item"
            :options="majorOptions"
            :placeholder="$t('student.classStudent.selectMajor')"
            @change="handleMajorChange"
          />
        </a-form-model-item>
        <a-form-model-item style="width: 100%" :label="$t('class.title')" prop="classId">
          <a-select v-model="moveForm.classId" :placeholder="$t('student.classStudent.selectClass')">
            <a-select-option v-for="cls in classOptions" :disabled="cls.id == $route.params.id" :key="cls.id" :value="cls.id">
              {{ cls.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 导入错误信息 -->
    <a-modal
      class="uploadStu"
      :title="$t('student.errorInfo.title')"
      :visible="infoVisible"
      :footer="null"
      width="800px"
      @cancel="infoVisible = false"
    >
      <a-table :columns="infoColumns" :data-source="infoData">
        <a slot="name" slot-scope="text">{{ text }}</a>
      </a-table>
      <div class="pagination">
        <Pagination class="list-pagination" :pagination.sync="infoPagination" @handleTableChange="handleInofTableChange" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { studentList, studentSave, studentDel, studentImport, studentExport, getAdminOrgList } from '@/api/lesson'
import { moveStudent, getAllClassList, studentDetail } from '@/api/admin'
import md5 from 'md5'
import cookie from 'js-cookie'
import { getListIndex } from '@/utils/other'
import NoData from '@/components/noData/index'
import UploadModal from '@/components/UploadModal.vue'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'

export default {
  components: {
    NoData,
    UploadModal,
    TipModal,
    Pagination
  },
  data() {
    return {
      visible: false,
      delId: undefined,
      editId: undefined,
      delVisible: false,
      classId: undefined,
      className: undefined,
      reviewVisible: false,
      uploadVisible: false,
      passwordFlag: false,
      repasswordFlag: false,
      studentFile: undefined,
      list: [],
      columns: [
        {
          title: this.$t('student.columns.index'),
          dataIndex: 'index',
          key: 'index',
          align: 'center'
        },
        {
          title: this.$t('student.columns.name'),
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: this.$t('student.columns.username'),
          dataIndex: 'username',
          key: 'username',
          align: 'center'
        },
        {
          title: this.$t('student.columns.operations'),
          dataIndex: 'operate',
          key: 'operate',
          align: 'center',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      locale: {
        emptyText: <NoData />
      },
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10,
        hideOnSinglePage: true
      },
      form: this.$form.createForm(this),
      reviewForm: this.$form.createForm(this),
      shortName: '@' + cookie.getJSON('user_infor').username.split('@')[1],
      infoColumns: [
        {
          title: this.$t('student.errorInfo.columns.name'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: this.$t('student.errorInfo.columns.username'),
          dataIndex: 'username',
          key: 'username'
        },
        {
          title: this.$t('student.errorInfo.columns.type'),
          dataIndex: 'type',
          key: 'type'
        },
        {
          title: this.$t('student.errorInfo.columns.message'),
          dataIndex: 'message',
          key: 'message'
        }
      ],
      infoData: [],
      infoVisible: false,
      infoPagination: {
        page: 1,
        total: 50,
        pageSize: 10,
        hideOnSinglePage: true
      },
      originalData: [],
      moveVisible: false,
      moveForm: {
        type: this.$route.query.type,
        majorId: [],
        classId: undefined,
        studentId: undefined
      },
      moveRules: {
        type: [{ required: true, message: '请选择班级类型', trigger: 'change' }],
        classId: [{ required: true, message: '请选择班级', trigger: 'change' }]
      },
      majorOptions: [],
      classOptions: [],
      emailSuffixes: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@gmail.com',
        '@hotmail.com',
        '@outlook.com',
        '@yahoo.com',
        '@sina.com',
        '@sohu.com'
      ],
      yearList: []
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'classList'
      })
    },
    create() {
      this.visible = true
      this.editId = undefined
      // 重置form
      this.form.resetFields()
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        const aa = this.$t('student.form.confirmPassword.notMatch')
        callback(aa)
      } else {
        callback()
      }
    },
    async editModal(obj) {
      this.editId = obj.id
      this.visible = true
      try {
        const res = await studentDetail({ id: obj.id })
        if (res.code === 200) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              name: res.data.name,
              gender: res.data.gender,
              password: undefined,
              repassword: undefined,
              username: res.data.username.split('@')[0],
              phone: res.data.phone,
              email: res.data.email,
              department: res.data.department,
              studentNumber: res.data.studentNumber,
              remark: res.data.remark,
              enrollmentYear: res.data.enrollmentYear
            })
          })
        }
      } catch (error) {
        console.error('获取学生详情失败:', error)
        this.$message.error('获取学生详情失败，请重试')
      }
    },
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(values, {
            id: this.editId,
            classId: this.classId,
            username: values.username + this.shortName,
            password: values.password ? md5(values.password) : undefined,
            status: 1
          })
          delete data.repassword
          studentSave(data).then(async res => {
            if (res.code !== 200) return
            this.visible = false
            this.$message.success(this.editId ? this.$t('student.edit') : this.$t('student.create'))
            this.pagination.page = 1
            this.getStudentList()
          })
        }
      })
    },
    async reviewModal(obj) {
      this.reviewVisible = true
      try {
        const res = await studentDetail({ id: obj.id })
        if (res.code === 200) {
          this.$nextTick(() => {
            this.reviewForm.setFieldsValue({
              name: res.data.name,
              gender: res.data.gender,
              username: res.data.username,
              phone: res.data.phone,
              email: res.data.email,
              department: res.data.department,
              studentNumber: res.data.studentNumber,
              remark: res.data.remark,
              enrollmentYear: res.data.enrollmentYear
            })
          })
        }
      } catch (error) {
        console.error('获取学生详情失败:', error)
        this.$message.error('获取学生详情失败，请重试')
      }
    },
    delModal(id) {
      this.delId = id
      this.delVisible = true
    },
    del() {
      studentDel({
        id: this.delId
      }).then(res => {
        if (res.code !== 200) return
        this.delVisible = false
        this.$message.success('删除成功')
        this.getStudentList()
      })
    },
    uploadModal() {
      this.uploadVisible = true
      this.studentFile = undefined
    },
    handleChange(file) {
      this.studentFile = file

      // this.studentFile = { ...formData }
    },
    uploadTemplate() {
      window.open(
        '/static/xlsx/学生导入模版.xlsx'
      )
    },
    uploadStudentFile() {
      if (!this.studentFile) {
        this.$message.error(this.$t('student.upload.uploadRequired'))
        return
      }
      const formData = new FormData() // 新建一个formdata用于存储数据
      formData.append('file', this.studentFile)
      formData.append('class_id', this.classId)
      console.log(formData.get('file'), formData.get('class_id'))
      studentImport(formData).then(res => {
        if (res.code !== 200) return
        const data = res.data.data || []
        this.uploadVisible = false
        this.$message.success(this.$t('student.upload.importSuccess'))
        this.pagination.page = 1
        this.getStudentList()
        console.log('data ----->', data)
        if (data.length > 0) {
          this.infoVisible = true
          this.originalData = data
          this.infoData = data.slice(0, 10)
          this.infoPagination.total = data.length
        }
      })
    },
    exportFile() {
      studentExport({
        classId: this.classId
      }).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, this.className)
        } else {
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          downloadElement.download = this.className
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href)
        }
        this.$message.success('下载成功')
      })
    },
    handleTableChange() {
      this.getStudentList()
    },
    getStudentList() {
      studentList({
        classIds: [this.classId],
        page: this.pagination.page
      }).then(res => {
        if (this.pagination.page > 1 && res.data.list.length === 0) {
          this.pagination.page = this.pagination.page - 1
          this.getStudentList()
        } else {
          this.list = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
          this.pagination.total = res.data.total
        }
      })
    },
    handleInofTableChange() {
      const startIndex = (this.infoPagination.page - 1) * this.infoPagination.pageSize
      const endIndex = startIndex + this.infoPagination.pageSize
      this.infoData = this.originalData.slice(startIndex, endIndex)
    },
    handleMove() {
      this.$refs.moveForm.validate(valid => {
        if (valid) {
          // 这里需要调用移动学生的API
          const data = {
            classId: this.classId,
            studentId: this.moveForm.studentId,
            toClassId: this.moveForm.classId
          }
          moveStudent(data).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('student.classStudent.moveSuccess'))
              this.moveVisible = false
              this.getStudentList()
            }
          })
        }
      })
    },
    moveModal(record) {
      this.moveVisible = true
      this.moveForm.studentId = record.id
      this.moveForm.type = this.$route.query.type
      this.getMajorList()
      this.getClassList()
    },
    async getMajorList() {
      try {
        const res = await getAdminOrgList()
        if (res.code === 200) {
          this.majorOptions = []
          for (const item of res.data.list) {
            this.majorOptions.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name
                    }
                  })
                }
              })
            })
          }
        }
      } catch (error) {
        console.error('获取专业列表失败:', error)
        this.$message.error('获取专业列表失败，请重试')
      }
    },
    handleTypeChange(value) {
      this.moveForm.type = value
      this.getClassList()
    },
    async handleMajorChange(value) {
      this.moveForm.majorId = value
      this.moveForm.classId = undefined
      this.getClassList()
    },
    async getClassList() {
      try {
        const res = await getAllClassList({
          professionId: this.moveForm.majorId[this.moveForm.majorId.length - 1],
          type: this.moveForm.type
        })
        if (res.code === 200) {
          this.classOptions = res.data.list
        }
      } catch (error) {
        console.error('获取班级列表失败:', error)
        this.$message.error('获取班级列表失败，请重试')
      }
    },
    validatePhone(rule, value, callback) {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (value && !phoneRegex.test(value)) {
        callback(this.$t('personal.form.modal.validate.phoneFormat'))
      } else {
        callback()
      }
    },
    handlePhoneInput(e) {
      const value = e.target.value
      const newValue = value.replace(/\D/g, '')
      if (value !== newValue) {
        e.target.value = newValue
        this.form.setFieldsValue({ phone: newValue })
      }
    },
    validateEmail(rule, value, callback) {
      if (!value) {
        callback()
        return
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
      if (!emailRegex.test(value)) {
        callback(this.$t('personal.form.modal.validate.emailFormat'))
        return
      }

      const atIndex = value.indexOf('@')
      const emailSuffix = value.substring(atIndex)
      if (!this.emailSuffixes.includes(emailSuffix)) {
        callback(this.$t('student.form.email.invalidSuffix'))
        return
      }

      callback()
    },
    generateYearList() {
      const currentYear = new Date().getFullYear()
      for (let year = currentYear; year >= 1990; year--) {
        this.yearList.push(String(year))
      }
    }
  },
  mounted() {
    this.className = this.$route.query.name
    this.classId = this.$route.query.id
    this.getStudentList()
    this.generateYearList()
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 19px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .header {
    display: flex;
    margin-bottom: 22px;
    padding-bottom: 12px;
    align-items: flex-end;
    justify-content: space-between;
    border-bottom: 1px solid #ededed;
    .title {
      font-size: 16px;
      font-weight: 800;
      color: #000000;
    }
    > div {
      .ant-btn-primary {
        margin-right: 22px;
        &:nth-child(2) {
          background: linear-gradient(90deg, #5889d5 0%, #3d87c9 100%);
        }
        &:nth-child(3) {
          margin-right: 0;
          background: linear-gradient(90deg, #a8cfa4 0%, #82b483 100%);
        }
      }
    }
  }
  .content {
    // height: 100%;
    width: 100%;
    position: relative;
    height: calc(100% - 48px - 22px - 34px - 25px);
    .nodata {
      height: 100%;
      display: flex;
      align-items: center;
      padding-bottom: 70px;
      justify-content: center;
      flex-direction: column;
      img {
        width: 285px;
        margin-bottom: 12px;
      }
      > div {
        width: 100%;
        display: flex;
        margin-top: -70px;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .text {
          font-weight: 550;
          color: #0d2340;
          margin-bottom: 12px;
        }
      }
    }
    .list {
      overflow-y: scroll;
      height: calc(100% - 30px);
      position: relative;
    }
    .list::-webkit-scrollbar {
      display: none;
    }
    .list-pagination {
      width: 100%;
      bottom: 40px;
      position: absolute;
    }
  }
}
/deep/.ant-form {
  display: flex;
  flex-wrap: wrap;
  .ant-form-item {
    &:nth-child(2n) {
      margin-left: 2%;
    }
    margin-bottom: 22px;
    width: 49%;
    .ant-input {
      height: 35px;
    }
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    .ant-form-item-no-colon {
      padding-left: 12px;
    }
    .ant-form-item-required.ant-form-item-no-colon {
      padding-left: 0;
    }
    &:last-child {
      margin-bottom: 12px;
    }
    .ant-textarea {
      border-radius: 4px;
      color: #000000;
      resize: none;
    }
  }
}
/deep/.ant-modal {
  .ant-input {
    height: 40px;
  }
  .ant-input-wrapper.ant-input-group {
    .ant-input {
      border-right: 0;
    }
    .ant-input-group-addon {
      background: #fff;
      font-size: 14px;
      font-weight: 400;
      color: #5e7a92;
      line-height: 20px;
    }
  }
  .ant-input-affix-wrapper {
    .ant-input-suffix img {
      width: 23px;
      height: 23px;
    }
  }
  .content {
    display: flex;
    position: relative;
    justify-content: center;
    .upload-file {
      width: 100%;
      height: 168px;
      position: relative;
      .file {
        top: 0;
        left: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        cursor: pointer;
        position: absolute;
      }
    }
    .success {
      width: 100%;
      height: 100%;
      display: flex;
      z-index: 2;
      color: #429a46;
      position: absolute;
      align-items: center;
      background: #fcfcfc;
      justify-content: center;
      border: 1px dashed #429a46;
      border-radius: 5px;
      font-size: 16px;
    }
    .fileTemplate {
      bottom: 40px;
      z-index: 1000;
      font-size: 12px;
      cursor: pointer;
      font-weight: 400;
      color: #7281a4;
      position: absolute;
      span {
        margin-right: 9px;
      }
      span:last-child {
        margin-right: 0;
      }
    }
  }
}
/deep/.ant-btn.file-button {
  width: 100% !important;
  height: 168px !important;
  padding-bottom: 20px;
  border-style: dashed;
  background: #fcfcfc;
  img {
    width: 26px;
    height: 26px;
    margin-bottom: 16px;
  }
  .text {
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
    letter-spacing: 1px;
  }
}
.uploadStu {
  /deep/ .ant-modal-footer {
    padding: 0px;
    padding-bottom: 20px;
  }
}

.pagination {
  position: relative;
  height: 50px;
  .list-pagination {
    width: 100%;
    bottom: 40px;
  }
}

/deep/ .ant-select {
  width: 100%;
}
</style>
